import { render, staticRenderFns } from "./popupPressalit.vue?vue&type=template&id=2b06c44e&lang=pug&"
import script from "./popupPressalit.vue?vue&type=script&lang=js&"
export * from "./popupPressalit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports